import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { SITE, SHOW_FEED } from "../config/site";
import SocialLinks from "../components/SocialLinks";

const NAV = [
  { label: "Capabilities", href: "/#capabilities" },
  { label: "Work", href: "/#work" },
  { label: "Print", href: "/print" },
  { label: "Events", href: "/events" },
  { label: "Feed", href: "/feed" },
  { label: "Process", href: "/#process" },
  { label: "Studio", href: "/#studio" },
].filter((l) => SHOW_FEED || l.href !== "/feed");

export default function Footer() {
  const navigate = useNavigate();
  const taps = useRef([]);
  const secretTap = () => {
    const now = Date.now();
    taps.current = taps.current.filter((t) => now - t < 1200);
    taps.current.push(now);
    if (taps.current.length >= 3) {
      taps.current = [];
      navigate("/admin");
    }
  };

  return (
    <footer data-testid="footer-section" className="border-t border-white/10 bg-ink">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" data-testid="footer-logo-link" className="inline-block" aria-label="Back to top">
              <img
                src="/images/logo.png"
                alt="Triple O Creative Industries"
                className="h-12 w-auto"
                draggable="false"
              />
            </a>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-fog">
              Creative production for cannabis brands.
            </p>
            <p
              data-testid="footer-address"
              className="mt-4 font-mono text-[10px] uppercase leading-relaxed tracking-[0.3em] text-paper/40"
            >
              {SITE.address1}
              <br />
              {SITE.address2}
            </p>
          </div>
          <nav className="md:col-span-3" aria-label="Footer">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-paper/40">Site</p>
            <ul className="mt-5 space-y-3">
              {NAV.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-sm text-paper/70 transition-colors duration-300 hover:text-acid"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-paper/40">Contact</p>
            <a
              href={`mailto:${SITE.email}`}
              data-testid="footer-email-link"
              className="mt-5 block font-display text-xl font-bold text-paper transition-colors duration-300 hover:text-acid sm:text-2xl"
            >
              {SITE.email}
            </a>
            <a
              href={SITE.phoneHref}
              data-testid="footer-phone-link"
              className="mt-3 block font-mono text-sm tracking-[0.15em] text-paper/70 transition-colors duration-300 hover:text-acid"
            >
              {SITE.phone}
            </a>
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-paper/40">
              {SITE.markets}
            </p>
            <p className="mt-3 font-mono text-[10px] uppercase leading-relaxed tracking-[0.25em] text-paper/40">
              {SITE.travel}
            </p>
            <div className="mt-6">
              <SocialLinks />
            </div>
          </div>
        </div>
        <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p
            data-testid="footer-copyright"
            data-secret-trigger
            onClick={secretTap}
            className="cursor-default select-none font-mono text-[10px] uppercase tracking-[0.25em] text-paper/40"
          >
            © 2026 Triple O Creative Industries. All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-paper/40">
            Design — Print — Fabricate — Install
          </p>
        </div>
      </div>
    </footer>
  );
}
